<script>
  import options from './CreateCancerForumProfile.options'
  export default options
</script>

<template>
  <article class="kb-create-cancer-forum-profile">
    <h1 class="kb-create-cancer-forum-profile__title">{{ getLabel('title') }}</h1>

    <hr />

    <div class="kb-create-cancer-forum-profile__form kb-optimizely-forms Form__Element">
      <h2 class="kb-create-cancer-forum-profile__form-title">{{ getLabel('formProfileTitle') }}</h2>
      <p class="kb-create-cancer-forum-profile__form-description">{{ getLabel('formProfileDescription') }}</p>

      <FormInputTextField 
        v-model="cancerForumName"
        fieldName="cancerForumName"
        :label="getLabel('formCancerForumNameLabel')"
        :isValidationError="displayError.name"
        :placeholder="getLabel('formCancerForumNameLabel')"
        :errorMessageLabel="cancerForumErrorLabel"
        :helpMessageLabel="getLabel('formCancerForumNameHelpText')"
      />

      <FormCheckbox 
        :v-model="cancerForumConsent.toString()"
        fieldName="cancerForumConsent"
        :label="getLabel('formCancerForumConsentLabel')"
        :isRichText="true"
        :isValidationError="!cancerForumConsent && displayError.consent"
        :errorMessageLabel="getLabel('formCancerForumConsentLabelError')"
        :onChangeCallback="(e) => setConsent(e)"
      />

      <button class="kb-button kb-button--full-color-spot" :class="{'kb-button--disabled': isSubmitting}" v-on:click="submitCreateProfile">
        {{ getLabel('submitButtonLabel') }}
      </button>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
        </div>
      </template>

    </div>
  </article>
</template>
